import React from "react";

export const PhoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2461 15.8762C17.462 15.1021 16.4832 15.1021 15.7041 15.8762C15.1098 16.4655 14.5155 17.0549 13.9312 17.6542C13.7713 17.819 13.6365 17.8539 13.4417 17.744C13.0572 17.5343 12.6477 17.3645 12.2781 17.1348C10.5551 16.051 9.11178 14.6577 7.83328 13.0895C7.19902 12.3104 6.63467 11.4764 6.24013 10.5375C6.16023 10.3477 6.17521 10.2228 6.33003 10.068C6.92434 9.49369 7.50366 8.90437 8.08798 8.31506C8.90203 7.49602 8.90203 6.53714 8.08298 5.7131C7.61853 5.24365 7.15407 4.78419 6.68961 4.31473C6.21017 3.83529 5.73572 3.35086 5.25129 2.87641C4.4672 2.11231 3.48834 2.11231 2.70925 2.88141C2.10995 3.47072 1.53562 4.07501 0.926333 4.65434C0.361991 5.18871 0.0773229 5.84295 0.0173928 6.60706C-0.0774965 7.8506 0.227148 9.02423 0.656647 10.1679C1.53562 12.5351 2.87406 14.6377 4.49717 16.5654C6.68961 19.1724 9.30656 21.235 12.368 22.7232C13.7464 23.3925 15.1747 23.9069 16.7279 23.9918C17.7967 24.0517 18.7256 23.782 19.4697 22.948C19.9791 22.3786 20.5534 21.8592 21.0928 21.3149C21.8919 20.5058 21.8969 19.527 21.1028 18.7279C20.1539 17.774 19.2 16.8251 18.2461 15.8762Z"
      fill="#FF3754"
    />
    <path
      d="M17.2921 11.8961L19.135 11.5815C18.8453 9.88849 18.0462 8.35528 16.8326 7.1367C15.5491 5.8532 13.926 5.04414 12.1381 4.79443L11.8784 6.64727C13.2618 6.84205 14.5203 7.46632 15.5142 8.46016C16.4531 9.39906 17.0674 10.5877 17.2921 11.8961Z"
      fill="#FF3754"
    />
    <path
      d="M20.1737 3.88547C18.0461 1.75795 15.3543 0.414516 12.3827 0L12.123 1.85284C14.6901 2.21242 17.0173 3.37606 18.8552 5.20892C20.5982 6.95189 21.7418 9.15432 22.1563 11.5765L23.9992 11.2619C23.5148 8.45513 22.1913 5.90811 20.1737 3.88547Z"
      fill="#FF3754"
    />
  </svg>
);
